import { Expose } from 'class-transformer'
import type { FamilyMemberResponse as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export type SerializedFamilyMemberResponse = Model

export default class FamilyMemberResponse implements CamelCaseKeys<SerializedFamilyMemberResponse> {
    archived?: Model['archived']

    @Expose({ name: 'family_photo' })
    familyPhoto?: Model['family_photo']

    @Expose({ name: 'family_role' })
    familyRole?: Model['family_role']

    id?: Model['id']

    @Expose({ name: 'profile_picture' })
    profilePicture?: Model['profile_picture']

    constructor(values: FamilyMemberResponse) {
        Object.assign(this, values)
    }
}
